var exports = {
  "i": "x234b8571--a18c8e--wrapper",
};

module.exports = exports;
